import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { EnvironmentsConfigsInterface } from '../interfaces/environments-configs.interface'

@Injectable({
	providedIn: 'root',
})
export class EnvironmentsHelperService {
	public environmentsConfigs$: BehaviorSubject<EnvironmentsConfigsInterface | null> =
		new BehaviorSubject<EnvironmentsConfigsInterface | null>(null)

	get apiUrl(): string | null {
		return this.environmentsConfigs$.getValue()?.api_url ?? null
	}

	get authUrl(): string | null {
		return this.environmentsConfigs$.getValue()?.auth_url ?? null
	}

	get socketUrl(): string | null {
		return this.environmentsConfigs$.getValue()?.socket_url ?? null
	}

	get socketMarketDataUrl(): string | null {
		return this.environmentsConfigs$.getValue()?.socket_market_data ?? null
	}

	get clientTradeUrl(): string | null {
		return this.environmentsConfigs$.getValue()?.client_trade_url ?? null
	}

	constructor() {}
}
